/*
|--------------------------------------------------------------------------
| API ROUTES
| All api routes are defined in this file, it's an easier way to maintain
|--------------------------------------------------------------------------
*/
export default {
  // Posts
  posts: 'wp-json/wp/v2/posts?_embed&per_page=3',
  post: 'wp-json/wp/v2/posts?_embed&slug=',
  // Pages
  page: 'wp-json/wp/v2/pages?_embed&slug=',
  pages: 'wp-json/wp/v2/pages?_embed',
  week_menu_page: 'wp-json/wp/v2/pages?_embed&slug=menus-de-la-semaine',
  galerie_page: 'wp-json/wp/v2/pages?slug=galerie',
  our_menu: 'wp-json/wp/v2/pages?slug=notre-carte',
  // Global
  slider: 'wp-json/acf/v3/options/theme-slider',
  footer: 'wp-json/acf/v3/options/theme-footer',
  month_offers: 'wp-json/acf/v3/options/theme-month-offers',
  navigation: 'wp-json/pomzed/v1/navigation',
  search: 'wp-json/pomzed/v1/search?s=',
  send_contact_form: 'https://komachi.pomzed.ch/send-contact-form.php',
  status: 'wp-json'
}



// WEBPACK FOOTER //
// ./src/api.js